export default function isNumber (number) {
  return typeof number === 'string'
    ? number.length > 0 && !isNaN(number)
    : typeof number === 'number';
}
